import { BaseHttpService, validateWithSchema } from "./BaseHttpService";
import { brandingSchema } from "@/api/http/schemas/brandingSchemas";
import type { Branding } from "@/api/http/schemas/brandingSchemas";

export const brandingEndpoints = {
  getBranding: "borrower_platform/branding/:id",
} as const;

export class BrandingHttpService extends BaseHttpService {
  screenLoadingPaths: string[] = [brandingEndpoints.getBranding];

  async getBranding(id: string) {
    const { data } = await this.get<{ data: Branding }>(
      brandingEndpoints.getBranding.replace(":id", id)
    );
    return validateWithSchema(brandingSchema, data);
  }
}
